module.exports = __webpack_public_path__ + "media/customizations/amblebrook/back-dddbf1b276c3fd66776b0c4af40a223a.jpg";